export default __webpack_public_path__ + "static/media/1-01.2874ccdf.png";